module.exports = __webpack_public_path__ + "static/media/lt.09f29719.jpeg";